module.exports = __webpack_public_path__ + "media/images/cropped-vouch365-logo-new-5380704a51d6119525060cc1d75869a4.png";